import { AuthProvider } from './context/AuthContext';
import AppContent from './AppContent';
import { Toaster } from './components/ui/sonner';
import { ChunkErrorBoundary } from './components/ChunkErrorBoundary';

function App() {
  return (
    <AuthProvider>

      <ChunkErrorBoundary>
        <AppContent />
      </ChunkErrorBoundary>
      <Toaster />
    </AuthProvider>
  );
}

export default App;


